export const typesNonProd = {
    GET_NON_PROD_SUCCESS:'GET_NON_PROD_SUCCESS',
    GET_NON_PROD_ERROR:'GET_NON_PROD_ERROR',
    GET_NON_PROD_BEGIN:'GET_NON_PROD_BEGIN'
}

export const subContainers = {
    HEADER_HOST_SYMMETRY:'Host Symmetry',
    HEADER_DB_SYMMETRY:'Database Symmetry',


}